/**
 * Enables the Insider membership pause feature to an audience.
 */ export var INSIDER_MEMBERSHIP_PAUSE_ENABLED = 'INSIDER_MEMBERSHIP_PAUSE_ENABLED';
